module.exports = __webpack_public_path__ + "static/images/components/TutorialArrow/images/back.b8297e87.png";


//////////////////
// WEBPACK FOOTER
// ./components/TutorialArrow/images/back.png
// module id = 2676
// module chunks = 11